import { ModalBase, Typography } from '@/components'
import { Breakpoint, ThemeColor } from '@/enums'
import { themeBreakpointUp, themeColor, useIsMobile } from '@/utils'
import { useTranslation } from 'react-i18next'
import styled, { keyframes } from 'styled-components'

const pulseAnimation = keyframes`
  100% {
    box-shadow: 0 0 0 80px #0000;
    width: 40px;
    height: 40px;
  }
  50% {
    width: 60px;
    height: 60px;
  }
  0% {
    width: 40px;
    height: 40px;
  }
`

const LoaderWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  padding-bottom: 48px;

  ${themeBreakpointUp(Breakpoint.tab)} {
    height: 500px;
    width: 500px;
  }
`

const StyledLoader = styled.div`
  width: 60px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: ${themeColor(ThemeColor.info1)};
  box-shadow: 0 0 0 0 ${themeColor(ThemeColor.info2)};
  animation: ${pulseAnimation} 1.5s infinite linear;
  position: relative;
`

const TextWrapper = styled.div`
  position: absolute;
  bottom: 25%;
  margin: auto;
`

interface Props {
  isVisible?: boolean
}

export const RecommendationLoader = ({ isVisible }: Props) => {
  const { isMobile } = useIsMobile()
  const { t } = useTranslation()
  return (
    <ModalBase isOpen={!!isVisible} fullscreen={isMobile}>
      <LoaderWrapper>
        <StyledLoader />
        <TextWrapper>
          <Typography variant="h5">
            {t('recommendations.customizingOfferLoaderLabel')}
          </Typography>
        </TextWrapper>
      </LoaderWrapper>
    </ModalBase>
  )
}
